module.exports = __webpack_public_path__ + "static/media/atomizer-3.50647605.jpg";